import type { FieldErrors, FieldValues, Path } from "react-hook-form"
import { useFormContext } from "react-hook-form"
// TODO move to @mallardbay/lib-react-components
// eslint-disable-next-line no-restricted-imports
import type { FormControlProps } from "@chakra-ui/react"
// TODO move to @mallardbay/lib-react-components
// eslint-disable-next-line no-restricted-imports
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
} from "@chakra-ui/react"
import React from "react"

import SubLabel from "~components/shared/form/sub-label"

interface FormControllerProps<TFieldValues extends FieldValues>
    extends Omit<FormControlProps, "label"> {
    readonly label?: React.ReactNode
    readonly name: Path<TFieldValues>
    readonly helperText?: string
    readonly children: React.ReactNode
    readonly htmlFor?: string
    readonly subLabel?: string
}

export default function HookFormControl<TFieldValues extends FieldValues>({
    label,
    name,
    helperText,
    children,
    htmlFor,
    subLabel,
    ...formControlProps
}: FormControllerProps<TFieldValues>) {
    const styles = useStyles(subLabel)
    const {
        formState: { errors },
    } = useFormContext<TFieldValues>()

    const fieldError = errors[name]

    const errorMessage = getErrorMessage(fieldError)
    const isInvalid = !!fieldError

    return (
        <FormControl
            {...formControlProps}
            isInvalid={isInvalid}
            data-testid={name}
        >
            {label && (
                <FormLabel htmlFor={htmlFor} {...styles.label}>
                    {label}
                </FormLabel>
            )}
            {subLabel && <SubLabel>{subLabel}</SubLabel>}
            {children}
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
            {errorMessage && (
                <FormErrorMessage>{errorMessage}</FormErrorMessage>
            )}
        </FormControl>
    )
}

function useStyles(subLabel?: string) {
    const label = {
        marginBottom: subLabel ? 0 : 2,
    }

    return {
        label,
    }
}

function getErrorMessage<TFieldValues extends FieldValues>(
    fieldError: FieldErrors<TFieldValues>[Path<TFieldValues>] | undefined
) {
    if (!fieldError) return undefined

    if (typeof fieldError.message === "string") {
        return fieldError.message
    }

    return undefined
}
